import { Navigate, useLocation } from 'react-router-dom';

export function LegacyCreditRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  if (params.get('view') === 'invoice_detail' && params.get('invoiceAccount')) {
    return <Navigate to={`/invoices${search}`} replace />;
  }

  return <Navigate to={`/transactions${search}`} replace />;
}
